import { Box, IconButton, Typography } from "@mui/material";
import { ArrowForward, ArrowUpward } from "@mui/icons-material";
import { Handle, Position } from "react-flow-renderer";
import { connect } from "react-redux";
import { Transition } from "../../../fstn/transition";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    handleContainer: {
        marginRight: "-7px",
        position: "relative"
    }
}));

interface Props
{
    id: string
    transitions: Transition[]
    onJump: (destination: string) => void
}

function Transitions({ id, onJump, transitions }: Props)
{
    const classes = useStyles();
    const handleJumpClick = (index: number) =>
    {
        onJump(transitions[index].destination || "");
    };

    return (
        <Box display="flex" flexDirection="column">
            {transitions.map((transition, index) => (
                <Box alignItems="center" key={index} display="flex" m={1}>
                    <Typography flexGrow={1} variant="body1">{transition.trigger}</Typography>
                    {
                        transition.meta?.type === "jump" &&
                        <IconButton onClick={() => handleJumpClick(index)}>
                            <ArrowForward />
                        </IconButton>
                    }
                    {
                        transition.meta?.type === "jumpState" &&
                        <IconButton onClick={() => handleJumpClick(index)}>
                            <ArrowUpward />
                        </IconButton>
                    }
                    {
                        transition.meta?.type !== "jump" && transition.meta?.type !== "jumpState" &&
                        <Box className={classes.handleContainer}>
                            <Handle type="source" position={Position.Right} id={`${id}.${index}`} isConnectable={true} />
                        </Box>
                    }
                </Box>
            ))
            }
        </Box >
    );
}

const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(Transitions);

